import {
  CarbonAvoidanceProjectType,
  CarbonRemovalProjectType,
  RestorationProjectType,
  ForestrySubType,
  ProjectSelector,
  ProjectSubType,
  ProjectType,
  RenewablesSubType,
  Wordpress,
} from "@ecologi/shared";
import community from "./animations/community.json";
import forest from "./animations/forest_1.json";
import turbines from "./animations/wind_turbines.json";

const IMAGE_PATH = "/images/app/forest";

type Project =
  | Exclude<ProjectType, ProjectSelector>
  | Exclude<ProjectSubType, ProjectSelector>;

type Image = { key: Project; path: string };
type Animation = {
  key: Project;
  animation: object;
  randomStart: boolean;
};
type ImageOrAnimation =
  | ({ type: "image" } & Image)
  | ({ type: "animation" } & Animation);

const projectsWithImage: Project[] = [
  CarbonAvoidanceProjectType.Wetlands,
  CarbonAvoidanceProjectType.Capture,
  CarbonAvoidanceProjectType.Community,
  CarbonAvoidanceProjectType.Transport,
  CarbonAvoidanceProjectType.Geothermal,
  RenewablesSubType.Hydro,
  RenewablesSubType.Wind,
  RenewablesSubType.Solar,
  RenewablesSubType.Biomass,
  ForestrySubType.ForestProtection,
  CarbonRemovalProjectType.AfforestationReforestationAndRevegetation,
  CarbonRemovalProjectType.BlueCarbon,
  CarbonRemovalProjectType.Biochar,
  CarbonRemovalProjectType.EnhancedRockWeathering,
  CarbonRemovalProjectType.RegenerativeAgriculture,
  RestorationProjectType.Wildflowers,
];

const projectsWithAnimations: Animation[] = [
  {
    key: ForestrySubType.ForestProtection,
    animation: forest,
    randomStart: true,
  },
  { key: RenewablesSubType.Wind, animation: turbines, randomStart: false },
  {
    key: CarbonAvoidanceProjectType.Community,
    animation: community,
    randomStart: true,
  },
];

export const getImageOrAnimation = (
  project?:
    | Wordpress.CarbonAvoidanceProject
    | Wordpress.CarbonRemovalProject
    | Wordpress.HabitatRestorationProject
): ImageOrAnimation | null => {
  if (!project) return null;
  const key = project.projectSubType || project.projectType;

  const animation = projectsWithAnimations.find((anim) => anim.key === key);

  if (animation) {
    return {
      type: "animation",
      ...animation,
    };
  }

  if (projectsWithImage.includes(key)) {
    return {
      type: "image",
      key,
      path: `${IMAGE_PATH}/${project.category}/${key}.svg`,
    };
  }

  return null;
};
